module.exports = "/images/vendor/flag-icon-css/flags/1x1/ph.svg?6ae85442fa90195cc9f34786a937e9d7";